// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2rKRt","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__15UGN"};